// matchUrlPattern — glob-like match dla pojedynczego wzorca przeciw pathname.
//
// Wspierane składnie:
//  - exact prefix: "/checkout" → matchuje "/checkout" i "/checkout/foo"
//  - wildcard *: "/account/*" → matchuje wszystko zaczynające się od "/account/"
//  - wildcard w środku: "/order/STAR/details" → match "/order/123/details"
//  - * jako extension: "*.pdf" → match każdego pathname kończącego się na ".pdf"
//
// Nie regex — owner panelu nie pisze regexpów. Wzorzec jest tłumaczony na
// regex z * → .* i resztą escape'owaną.
//
// Pusty/nieprawidłowy wzorzec → false (nigdy nie matchuje).
export function matchUrlPattern(pattern: string, pathname: string): boolean {
  const trimmed = pattern.trim();
  if (trimmed === '') return false;

  // Escape regex special chars OPRÓCZ *, potem * → .*
  const escaped = trimmed.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*');

  // Bez * na końcu = prefix match (popularny use case: "/checkout" ma matchować
  // też "/checkout/123"). Z * na końcu już mamy ".*" → naturalne dopasowanie.
  const needsPrefixAnchor = !trimmed.includes('*');
  const regex = needsPrefixAnchor
    ? new RegExp('^' + escaped + '(/|$)')
    : new RegExp('^' + escaped + '$');

  try {
    return regex.test(pathname);
  } catch {
    return false;
  }
}
